<template>
  <div class="demand-content">
    <div v-if="false">
      <div
        v-for="(item, i) in dataList"
        :key="i"
        class="item"
        @click="jumpToDetail(item, i)"
      >
        <el-tooltip
          :show-after="500"
          effect="dark"
          :content="item.title"
          placement="top-start"
        >
          <div class="text">{{ item.title }}</div>
        </el-tooltip>
      </div>
    </div>
    <div
      v-if="false"
      class="no-data-container"
    >
      <div class="box">
        <svg-icon
          icon-class="no-data"
          class="no-data"
        />
        <div class="info">还没有公告</div>
      </div>
    </div>
    <el-dialog
      v-model="dialogVisible"
      class="public-dialog"
      modal-class="public-dialog-modal"
      width="1000px"
    >
      <template #header="{ titleId, titleClass }">
        <div class="my-header">
          <div
            :id="titleId"
            :class="titleClass"
          >
            <svg-icon
              icon-class="up-arrow"
              class="icon"
            />
            <b>公告栏</b>
          </div>
        </div>
      </template>
      <div class="allaffiche">
        <el-steps
          :active="-1"
          direction="vertical"
        >
          <el-step
            v-for="(item, index) in alllist"
            :key="index"
            :class="'gg' + index"
            :title="item.date"
          >
            <template #icon>
              <span class="dian"></span>
            </template>
            <template #description>
              <div class="cons">
                <h3>{{ item.title }}</h3>
                <div
                  v-for="(e) in item.newFeatures"
                  :key="e"
                >
                  新增功能：{{ e }}
                </div>
                <div
                  v-for="(e) in item.optimizations"
                  :key="e"
                >
                  优化功能：{{ e }}
                </div>
              </div>
            </template>
          </el-step>
        </el-steps>
      </div>
    </el-dialog>
  </div>
</template>
<script lang="ts" setup>
  import {
    ref, onMounted, computed, nextTick,
  } from 'vue';
  import { getboard } from '@/api/modules/home';

  interface listitem {
    title: string,
    date: string,
    newFeatures: Array<string>,
    optimizations: Array<string>,
  }
  const dataList = ref<Array<listitem>>([]);
  const showList = computed(() => dataList.value.length && dataList.value.length > 0);
  const alllist = ref<Array<listitem>>([]);
  const dialogVisible = ref(false);

  const getList = () => {
    getboard().then((res: any) => {
      if (res.code === '200' && res.data && res.data.items) {
        res.data.items.reverse();
        alllist.value = res.data.items || [];
        dataList.value = res.data.items.slice(0, 3) || [];
      }
    });
  };

  const jumpToDetail = (item: any, index: any) => {
    console.log(item);
    dialogVisible.value = true;
    nextTick(() => {
      const el = document.querySelector(`.gg${index}`) as HTMLElement;
      const top = el.offsetTop - 76;
      const fe = document.querySelector('.el-dialog__body') as HTMLElement;
      fe.scrollTo({ behavior: 'smooth', top });
    });
  };

  function viewallbulletin() {
    dialogVisible.value = true;
    nextTick(() => {
      const fe = document.querySelector('.el-dialog__body') as HTMLElement;
      fe.scrollTo({ behavior: 'smooth', top: 0 });
    });
  }

  onMounted(() => {
    getList();
  });

  defineExpose({ viewallbulletin, dataList });

</script>
<style lang="scss" scoped>
.demand-content {
  padding-top: 13px;

  .demand-info {
    margin-right: 6px;
    padding: 4px 6px;
    font-size: var(--el-font-size-base);
    white-space: nowrap;
    border-radius: 2px;

    &.wait {
      color: $--color-status-orange;
      background-color: $--color-status-orange-bg;
    }

    &.ongoing {
      color: $--color-status-blue;
      background-color: $--color-status-blue-bg;
    }

    &.done {
      color: $--color-status-gray;
      background-color: $--color-status-gray-bg;
    }
  }

  .item {
    display: flex;
    align-items: center;
    padding: 9px 4px;
    background: $--color-white;
    border-bottom: 1px solid $--color-grey-2;
    cursor: pointer;

    .text {
      overflow: hidden;
      color: var(--el-text-color-primary);
      font-size: var(--el-font-size-base);
      line-height: 18px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .circle {
    flex-shrink: 0;
    width: 6px;
    height: 6px;
    margin-right: 6px;
    border-radius: 50%;

    &.wait {
      background-color: $--color-status-orange;
    }

    &.ongoing {
      background-color: $--color-status-blue;
    }

    &.done {
      background-color: $--color-status-gray;
    }
  }
}

.no-data-container {
  display: flex;
  justify-content: center;
  margin-top: 60px;

  .box {
    display: flex;
    flex-direction: column;
    align-items: center;

    .no-data {
      width: 90px;
      height: 90px;
      color: #DEE4F2;
    }

    .btn {
      display: flex;
      align-items: center;
      height: 30px;
      margin-top: 12px;
      padding: 2px 18px;
      background: $--color-grey-4;
      border: 1px solid $--color-grey-2;
      border-radius: 3px;
      cursor: pointer;

      .plus {
        font-size: calc(var(--el-font-size-base) + 1px);
      }

      .new-demand {
        margin-left: 4px;
      }
    }

    .info {
      margin-top: 12px;
      color: $--color-info-gray;
      font-weight: 400;
      font-size: var(--el-font-size-base);
      line-height: 15px;
      text-align: center;
    }
  }
}
</style>
<style lang="scss">
  .public-dialog{
    .el-step__icon.is-text{
      border: 0;
    }

    .dian{
      width: 8px;
      height: 8px;
      background: #D9D9D9;
      border-radius: 8px;
    }

    .allaffiche{
      .el-step__title{
        padding-bottom: 20px;
        color: #4E4E4E;
        font-weight: 400;
        font-size: 16px;
      }

      .el-step__line{
        width: 1px;
      }

      .el-step:last-of-type .el-step__line{
        display: block;
      }
    }

    .cons{
      margin-bottom: 30px;

      h3{
        margin-bottom: 20px;
        color: #111;
        font-weight: 500;
        font-size: 24px;
        line-height: 28px;
      }

      div{
        color: var(--text-g-2-text-2-icon, #434C59);
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
      }
    }
  }
</style>
